<template>
  <div class="container">
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 v-if="plano._id" class>Configuração Split Plano: {{plano.name}}</h3>
            </div>
            <div class="col-auto">
              <b-button @click="$router.push({ name: 'EmpresaPlano' })">Voltar</b-button>
              <b-button @click="$bvModal.show('modalProdutoSplitForm')">Novo</b-button>
            </div>
          </div>
        </div>

        <div class="element-box">
          <b-table id="tblAfiliados" :items="afiliados" :fields="fields" class="mt-3" outlined>
            <template #participacao="row">
              {{ row.item.tipoComissao === 'PORCENTAGEM' ? '%' : 'R$'}} {{row.item.valorRepasse}}
            </template>
            <template #afiliadoNome="row">
              {{row.item.afiliado.nome}} <b>({{row.item.afiliado.email}})</b>
            </template>
            <template #actions="row">
              <b-button
                  v-if="row.item.status !== 'ATIVO'"
                  variant="outline-success"
                  size="sm"
                  title="Ativar Grupo Serviço"
                  @click="ativar(row.item)"
              >
                <i class="fa fa-check"></i>
              </b-button>
              <b-button
                  v-if="row.item.status === 'ATIVO'"
                  title="Desativar Grupo Serviço"
                  variant="outline-danger"
                  size="sm"
                  @click="desativar(row.item)"
              >
                <i class="fa fa-minus"></i>
              </b-button>
              <b-button
                  v-if="row.item.status === 'ATIVO'"
                  variant="outline-primary"
                  size="sm"
                  title="Editar"
                  @click="edit(row.item)"
              >
                <i class="fa fa-edit"></i>
              </b-button>
            </template>
          </b-table>
        </div>

      </div>
    </div>

    <b-modal hide-footer id="modalProdutoSplitForm" size="lg"
             ref="modalProdutoSplitForm"
             title="Participante Split">
      <form @submit.prevent="saveSplit">
        <b-card>
          <div class="container">
            <div class="row mb-3">
              <div class="col">
                <label>Valor Plano:</label>
                <h5>{{plano.price | money}}</h5>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label>Afiliado</label>
                  <b-select v-model="afiliadoForm.afiliado">
                    <template #first>
                      <option :value="null">Selecione</option>
                    </template>
                    <option
                        v-for="(afiliado) in afiliadosSELECT"
                        :key="afiliado._id"
                        :value="afiliado">
                      {{ afiliado.nome }} ({{ afiliado.email}})
                    </option>
                  </b-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label>Tipo de Comissão</label>
                  <b-select v-model="afiliadoForm.tipoComissao" :options="tipoComissao">
                    <template #first>
                      <option :value="null">Selecione</option>
                    </template>
                  </b-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label>Valor de Repasse</label>
                  <template v-if="afiliadoForm.tipoComissao && afiliadoForm.tipoComissao === 'VALOR FIXO'">
                    <money required v-model="afiliadoForm.valorRepasse" name="valorRepasse"
                           v-validate="'required'" class="form-control" id="valorRepasse" />
                  </template>
                  <template v-if="afiliadoForm.tipoComissao && afiliadoForm.tipoComissao === 'PORCENTAGEM'">
                    <input type="tel" maxlength="100" v-model="afiliadoForm.valorRepasse" name="porcentagem"
                           required class="form-control" id="porcentagem" />
                  </template>

                </div>
              </div>
            </div>
          </div>
          <template v-slot:footer>
            <b-button type="submit" variant="primary" >Salvar</b-button>
          </template>
        </b-card>
      </form>
    </b-modal>
  </div>
</template>
<script>
import axios from "axios";

export default {
  async created() {
    let id = this.$route.query.id;
    if (id) {
      const response = await axios.get(`/api/plan/id/${id}`);
      this.plano = response.data;
      this.beneficioSelecteds = this.plano.beneficiosPlano
      this.cobrarTaxaAdesao = this.plano.valorTaxaAdesao ? true : false
      this.planoComDependentes = this.plano.qtdDependentes ? true : false
    }

    this.afiliadosSELECT = await axios.get(`/api/afiliados?status=active&empresa=${this.empresa._id}`).then(response => response.data)

    this.afiliados = await axios.get(`/api/planSplit?empresa=${this.empresa._id}&plano=${this.plano._id}&populate=afiliado`).then(response => response.data)

  },
  computed: {
    empresa() {
      return this.$store.getters.empresa;
    }
  },
  data: () => ({
    plano: {},
    afiliadosSELECT: [],
    afiliados: [],
    afiliadoForm: {
      afiliado: null,
      tipoComissao: null,
      valorRepasse: null
    },
    tipoComissao: ['PORCENTAGEM', 'VALOR FIXO'],
    fields: [
      { key: 'status', label: 'Status'},
      { key: 'afiliadoNome', label: 'Nome', sortable: true},
      { key: 'participacao', label: '% / R$', sortable: true},
      { key: 'actions', label: 'Ações', sortable: false},
    ]
  }),
  methods: {
    async saveSplit() {
      try {
        this.$store.dispatch('setLoading', true);

        await axios.post('/api/plansplit', {
          empresa: this.empresa._id,
          afiliado: this.afiliadoForm.afiliado,
          plano: this.plano,
          valorRepasse: this.afiliadoForm.valorRepasse,
          tipoComissao: this.afiliadoForm.tipoComissao
        })

        this.$root.$emit('bv::refresh::table', 'tblAfiliados')
        this.$bvModal.hide('modalProdutoSplitForm')
      } catch (e) {
        alert('Falha ao cadastrar Split')
      } finally {
        this.$store.dispatch('setLoading', false);
      }
    }
  }
}
</script>